module.exports = __webpack_public_path__ + "static/img/zybb.b39db1d5.svg";